import Icon from "../Icon";
import React from "react";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import useEvent from "../../hooks/useEvent";

const FooterContacts = () => {
  const event = useEvent();

  return event === "IADR" ? (
    <>
      <div className="mb-4">
        <a
          href="https://www.facebook.com/iadrsea/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="flex items-center justify-start">
            <div className="text-4xl text-aqua">
              <Icon icon={faFacebookSquare} />
            </div>
            <div className="ml-4 text-base font-bold text-aqua">
              IADR-Southeast Asian Division
            </div>
          </div>
        </a>
      </div>
      <div className="w-8 h-1 mb-4 bg-aqua"></div>
      <div className="text-sm text-gray-400">
        <span className="mr-2 font-bold">E</span>{" "}
        <a
          href="mailto:iadr.sea@gmail.com"
          className="transition duration-300 hover:text-black"
        >
          IADR.SEA@gmail.com
        </a>
        <br />
        <span className="mr-2 font-bold">T</span>{" "}
        <a
          href="tel:+9592024341"
          className="transition duration-300 hover:text-black"
        >
          (+95) 9 202 4341
        </a>
      </div>
    </>
  ) : null;
};

export default FooterContacts;
